import React, { FC } from 'react';

import { TIFormatPrefix } from '../../../../store/admin/roundFormats/store';

import { useAssignResultsState } from '../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';

import { CTPTable } from '../CTPTable/CTPTable';
import { GBNTable } from '../GBNTable/GBNTable';
import { MoneyBallTable } from '../MoneyBallTable/MoneyBallTable';
import RaceTable from '../RaceTable/RaceTable';
import { ScoreTable } from '../ScoreTable/ScoreTable';
import { SkinsTable } from '../SkinsTable/SkinsTable';
import { TeamFormatTable } from '../TeamFormatTable/TeamFormatTable';
import { useEventLeaderboardsState } from '../Context/EventLeaderboards.context';

const ResultsTable: FC = () => {
  const { selectedFormat, selectedTeamFormat } = useAssignResultsState();

  const { selectedRound, selectedFlightId: flightId } = useEventLeaderboardsState();

  const roundId = selectedRound ? Number(selectedRound.id) : selectedRound;

  const tablesMap = {
    ctp: <CTPTable />,
    gbn: <GBNTable roundId={roundId} />,
    horse: <RaceTable roundId={roundId} flightId={flightId} />,
    moneyBall: <MoneyBallTable />,
    moneyball: <MoneyBallTable />,
    scramble: <TeamFormatTable roundId={roundId} teamFormat="teamStrokeBetterball" />,
    skins: <SkinsTable roundId={roundId} />,
    stroke: <ScoreTable roundId={roundId} flightId={flightId} />,
    teamstroke: <ScoreTable roundId={roundId} flightId={flightId} />
  };

  if (selectedTeamFormat && roundId) {
    return <TeamFormatTable roundId={roundId} />;
  }

  if (!selectedFormat) {
    return <p>Please, select a format</p>;
  }

  const selectedFormatTable = tablesMap[selectedFormat.prefix.replace('_', '') as TIFormatPrefix];

  return selectedFormatTable ? selectedFormatTable : <p>Format not yet implemented</p>;
};

export default ResultsTable;
